import duckService from '../service/duck';
import Vue from 'vue';

const state =
{
    loading: false,
    ducks: [],
};

const actions = {

    saveDuckPeriodic({ commit }, { macAddress, period }) {
        return duckService.saveDuckPeriodic(macAddress, period);
    },
    getDuckPeriodic({ commit }, macAddress) {
        return duckService.getDuckPeriodic(macAddress);

    },
    setDuckTrigger({ commit }, { duck, trigger }) {
        return duckService.setDuckTrigger(duck, trigger);
    },

    deleteDuckTrigger({ commit }, { duck, trigger }) {
        return duckService.deleteDuckTrigger(duck, trigger);
    },
    deleteDuckPeriodic({ commit }, macAddress) {
        return duckService.deleteDuckPeriodic(macAddress);

    },

    getDucks({ commit }) {
        commit('setLoading', true);
        return duckService.getDucks().then(ducks => {
            commit('setDucks', ducks);
        }).finally(() =>
            commit('setLoading', false)
        );
    },

    saveDuckConfig({ commit }, { id, duckConfig }) {
        commit('setLoading', true);
        return duckService.saveDuckConfig(id, duckConfig).then(duck => {
            commit('setDuckConfig', { id, duckConfig });
        }).finally(() =>
            commit('setLoading', false)
        );
    },



};
const mutations = {

    setLoading(state, bool) {
        state.loading = bool;
    },
    setDuckConfig(state, { id, duckConfig }) {
        let index = state.ducks.findIndex(x => x._id == id);
        if (index != -1) {
            Vue.set(state.ducks[index], 'config', duckConfig);
        }
    },

    setDucks(state, ducks) {
        state.ducks = ducks;
        state.loading = false;
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
